import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export function SectionSkeleton({ contentHeight = "h-40" }: { contentHeight?: string }) {
  return (
    <Card>
      <CardContent className="pt-6">
        <Skeleton className="mb-4 h-6 w-40" />
        <Skeleton className={cn("w-full", contentHeight)} />
      </CardContent>
    </Card>
  );
}
